/*
 * @Description: 
 * @Autor: liyingzero
 * @Date: 2022-09-01 23:39:04
 * @LastEditors: liyingzero
 * @LastEditTime: 2022-09-08 16:20:48
 */
export const getXtdPreviewData = () => (
    {
        "activityCommon": {
            "cityID": "52090100",
            "cityName": "Mexico City",
            "activeCode": "DJKLDKAL234",
            "activityID": 23423432,
            "showCode": "FOOD-XXXXXX",
            "share": {
                "referralCode": "Regístrate con este código FOOD-L5DSTV y comienza a ganar con DiDi Food.",
                "whatsapp": {
                    "title": "Comienza a ganar con DiDi Food.",
                    "content": "Sube tus documentos hoy, es fácil y rápido.",
                    "icon": "https://img0.didiglobal.com/static/soda_public/do1_tY3nyvc1tgZCB5ipRjrt"
                },
                "messenger": {
                    "title": "Comienza a ganar con DiDi Food.",
                    "content": "Sube tus documentos hoy, es fácil y rápido.",
                    "icon": "https://img0.didiglobal.com/static/soda_public/do1_tY3nyvc1tgZCB5ipRjrt"
                },
                "facebook": {
                    "title": "Comienza a ganar con DiDi Food.",
                    "content": "Sube tus documentos hoy, es fácil y rápido.",
                    "icon": "https://img0.didiglobal.com/static/soda_public/do1_tY3nyvc1tgZCB5ipRjrt"
                },
                "twitter": {
                    "title": "Comienza a ganar con DiDi Food.",
                    "content": "Sube tus documentos hoy, es fácil y rápido.",
                    "icon": "https://img0.didiglobal.com/static/soda_public/do1_tY3nyvc1tgZCB5ipRjrt"
                },
                "default": {
                    "title": "Comienza a ganar con DiDi Food.",
                    "content": "Sube tus documentos hoy, es fácil y rápido.",
                    "icon": "https://img0.didiglobal.com/static/soda_public/do1_tY3nyvc1tgZCB5ipRjrt"
                }
            },
            "shareOrder": [
                "whatsapp",
                "facebook",
                "telegram",
                "twitter"
            ],
            "pending": 0,
            "pending_display": "MX$0.00",
            "pending_highlight_display": {
                "symbol": "MX$",
                "number": "0.00",
                "position": 0,
                "display": "MX$0.00",
                "sign": ""
            },
            "rewarded": 3000,
            "rewarded_display": "MX$0.00",
            "rewarded_highlight_display": {
                "symbol": "MX$",
                "number": "0.00",
                "position": 0,
                "display": "MX$0.00",
                "sign": ""
            },
            "currency": 0,
            "version": 0,
            "validation": 1
        },
        "ruleDetail": {
            "0": {
                "title": "Referee’s Registration Time",
                "subText": "",
                "message": "",
                "time": [
                    1634241600,
                    1635570000
                ],
                "time_display": {
                    "startTime": {
                        "timestamp": 1634241600,
                        "offset": -18000
                    },
                    "endTime": {
                        "timestamp": 1635570000,
                        "offset": -18000
                    }
                },
                "isAmountShow": 0,
                "amount": 0,
                "children": []
            },
            "1": {
                "title": "Delivery method",
                "subText": "",
                "message": "xxx, xxx, xxxxx",
                "time": [],
                "time_display": {},
                "isAmountShow": 0,
                "amount": 0,
                "children": []
            },
            "2": {
                "title": "How to Get Rewards",
                "subText": "",
                "message": "",
                "time": [],
                "time_display": {},
                "isAmountShow": 0,
                "amount": 0,
                "children": [],
                "steps": [
                    {
                        "title": "",
                        "subText": "reward rule reward rule reward rule ",
                        "message": "",
                        "time": [],
                        "time_display": {},
                        "isAmountShow": 0,
                        "amount": 0,
                        "children": [
                            {
                                "title": "",
                                "subText": "reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule ",
                                "message": "",
                                "time": [],
                                "amount": 0,
                                "isAmountShow": 0,
                                "children": []
                            }
                        ]
                    },
                    {
                        "title": "",
                        "subText": "reward rule reward rule reward rule",
                        "message": "",
                        "time": [],
                        "time_display": {},
                        "isAmountShow": 0,
                        "amount": 0,
                        "children": [
                            {
                                "title": "",
                                "subText": "reward rule reward rule ",
                                "message": "reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule ",
                                "time": [],
                                "time_display": {},
                                "amount": 0,
                                "isAmountShow": 0,
                                "children": []
                            },
                            {
                                "title": "",
                                "subText": "reward rule reward rule ",
                                "message": "",
                                "time": [],
                                "time_display": {},
                                "amount": 0,
                                "isAmountShow": 0,
                                "children": []
                            },
                            {
                                "title": "",
                                "subText": "reward rule reward rule",
                                "message": "reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule ",
                                "time": [],
                                "time_display": {},
                                "amount": 0,
                                "isAmountShow": 0,
                                "children": []
                            },
                            {
                                "title": "",
                                "subText": "reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule ",
                                "message": "",
                                "time": [],
                                "time_display": {},
                                "amount": 0,
                                "isAmountShow": 0,
                                "children": []
                            }
                        ]
                    },
                    {
                        "title": "",
                        "subText": "reward rule ",
                        "message": "",
                        "time": [],
                        "time_display": {},
                        "isAmountShow": 0,
                        "amount": 0,
                        "children": [
                            {
                                "title": "",
                                "subText": "reward rule reward rule reward rule reward rule reward rule reward rule ",
                                "message": "",
                                "time": [],
                                "time_display": {},
                                "amount": 0,
                                "isAmountShow": 0,
                                "children": []
                            },
                            {
                                "title": "",
                                "subText": "reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule ",
                                "message": "",
                                "time": [],
                                "time_display": {},
                                "isAmountShow": 0,
                                "amount": 0,
                                "children": []
                            },
                            {
                                "title": "",
                                "subText": "reward rule reward rule reward rule reward rule reward rule reward rule reward rule ",
                                "message": "",
                                "time": [],
                                "time_display": {},
                                "isAmountShow": 0,
                                "amount": 0,
                                "children": []
                            }
                        ]
                    }
                ]
            },
            "3": {
                "title": "reward rule ",
                "subText": "",
                "message": "",
                "time": [],
                "time_display": {},
                "isAmountShow": 0,
                "amount": 0,
                "children": [
                    {
                        "title": "",
                        "subText": "reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule reward rule ",
                        "message": "",
                        "time": [],
                        "time_display": {},
                        "isAmountShow": 0,
                        "amount": 0,
                        "children": []
                    },
                    {
                        "title": "",
                        "subText": "reward rule reward rule reward rule reward rule ",
                        "phone": "0120-052-335",
                        "message": "",
                        "time": [],
                        "time_display": {},
                        "isAmountShow": 0,
                        "amount": 0,
                        "children": []
                    },
                    {
                        "title": "",
                        "subText": "reward rule reward rule ",
                        "phone": "",
                        "message": "https://m.didiglobal.com/static/gstar/page/market/ddPage_0C7Eg1b5.html",
                        "time": [],
                        "time_display": {},
                        "isAmountShow": 0,
                        "amount": 0,
                        "children": []
                    }
                ]
            },
            "currency": "MXN",
            "version": 0,
            "countryCode": "MX"
        }
    }
)